function _typeof(o) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (o) {
        return typeof o;
    } : function (o) {
        return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', { writable: false });
    return Constructor;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, 'string');
    return 'symbol' == _typeof(i) ? i : i + '';
}
function _toPrimitive(t, r) {
    if ('object' != _typeof(t) || !t)
        return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != _typeof(i))
            return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return ('string' === r ? String : Number)(t);
}
import utils, { isMobile } from './utils';
var Controller = function () {
    function Controller(player) {
        var _this = this;
        _classCallCheck(this, Controller);
        this.player = player;
        this.autoHideTimer = 0;
        if (!isMobile) {
            this.player.container.addEventListener('mousemove', function () {
                _this.setAutoHide();
            });
            this.player.container.addEventListener('click', function () {
                _this.setAutoHide();
            });
            this.player.template.controller.addEventListener('mouseenter', function () {
                _this.disableAutoHide = true;
            });
            this.player.template.controller.addEventListener('mouseleave', function () {
                _this.disableAutoHide = false;
            });
            this.player.template.controllerMask.addEventListener('mouseenter', function () {
                _this.disableAutoHide = true;
            });
            this.player.template.controllerMask.addEventListener('mouseleave', function () {
                _this.disableAutoHide = false;
            });
            this.player.template.mask.addEventListener('mouseenter', function () {
                _this.disableAutoHide = true;
            });
            this.player.template.videoWrap.addEventListener('click', function () {
                _this.player.toggle();
            });
            this.player.template.controllerMask.addEventListener('click', function () {
                _this.player.toggle();
            });
        } else {
            this.player.template.videoWrap.addEventListener('click', function () {
                _this.toggle();
            });
            this.player.template.controllerMask.addEventListener('click', function () {
                _this.toggle();
            });
        }
        this.initPlayButton();
        this.initVolumeButton();
        this.initScreenshotButton();
        this.initFullButton();
    }
    return _createClass(Controller, [
        {
            key: 'initPlayButton',
            value: function initPlayButton() {
                var _this2 = this;
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Play';
                var icon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'play';
                this.player.template.play.innerHTML = this.player.template.tplButton(name, icon);
                var button = this.player.template.play.querySelector('button');
                button.addEventListener('click', function () {
                    _this2.player.toggle();
                });
            }
        },
        {
            key: 'initPrevButton',
            value: function initPrevButton(show) {
                var _this3 = this;
                this.player.template.prev.innerHTML = this.player.template.tplButton('Prev', 'prev', !show, function (content) {
                    var image = _this3.player.cameras[_this3.player.currentChannel - 1].image;
                    var name = _this3.player.cameras[_this3.player.currentChannel - 1].name;
                    return content('tplCameraPreview', {
                        'image': image,
                        'description': name
                    });
                });
                if (show) {
                    var prevButton = this.player.template.prev.querySelector('button');
                    prevButton.addEventListener('click', function () {
                        _this3.player.switchVideo(_this3.player.currentChannel - 1, _this3.player.currentQuality);
                    });
                }
            }
        },
        {
            key: 'initNextButton',
            value: function initNextButton(show) {
                var _this4 = this;
                this.player.template.next.innerHTML = this.player.template.tplButton('Next', 'next', !show, function (content) {
                    var image = _this4.player.cameras[_this4.player.currentChannel + 1].image;
                    var name = _this4.player.cameras[_this4.player.currentChannel + 1].name;
                    return content('tplCameraPreview', {
                        'image': image,
                        'description': name
                    });
                });
                if (show) {
                    var nextButton = this.player.template.next.querySelector('button');
                    nextButton.addEventListener('click', function () {
                        _this4.player.switchVideo(_this4.player.currentChannel + 1, _this4.player.currentQuality);
                    });
                }
            }
        },
        {
            key: 'initVolumeButton',
            value: function initVolumeButton() {
                var _this5 = this;
                this.player.template.volume.innerHTML = '';
                if (this.player.options.volume) {
                    this.player.template.volume.innerHTML = this.player.template.tplButton('Volume', 'volume-down', false, function (content) {
                        return content('tplVolume');
                    });
                    var vWidth = 35;
                    var volumeBar = this.player.template.volume.querySelector('.lineplayer-volume-bar-inner');
                    var volumeBarWrap = this.player.template.volume.querySelector('.lineplayer-volume-bar');
                    var volumeBarWrapWrap = this.player.template.volume.querySelector('.lineplayer-volume-bar-wrap');
                    var volumeIcon = this.player.template.volume.querySelector('.lineplayer-icon-content');
                    this.player.bar.add('volume', volumeBar);
                    var volumeMove = function volumeMove(event) {
                        var e = event || window.event;
                        var percentage = (e.clientX - utils.getElementViewLeft(volumeBarWrap) - 5.5) / vWidth;
                        _this5.player.volume(percentage, false, true);
                    };
                    var volumeUp = function volumeUp() {
                        document.removeEventListener('mouseup', volumeUp);
                        document.removeEventListener('mousemove', volumeMove);
                        _this5.player.template.volume.classList.remove('lineplayer-volume-active');
                    };
                    volumeBarWrapWrap.addEventListener('click', function (event) {
                        var e = event || window.event;
                        var percentage = (e.clientX - utils.getElementViewLeft(volumeBarWrap) - 5.5) / vWidth;
                        _this5.player.volume(percentage, false, true);
                    });
                    volumeBarWrapWrap.addEventListener('mousedown', function () {
                        document.addEventListener('mousemove', volumeMove);
                        document.addEventListener('mouseup', volumeUp);
                        _this5.player.template.volume.classList.add('lineplayer-volume-active');
                    });
                    var volumeButton = this.player.template.volume.querySelector('button');
                    volumeButton.addEventListener('click', function () {
                        if (_this5.player.video.muted) {
                            _this5.player.video.muted = false;
                            _this5.player.switchVolumeIcon();
                            _this5.player.bar.set('volume', _this5.player.volume(), 'width');
                        } else {
                            _this5.player.video.muted = true;
                            volumeIcon.innerHTML = _this5.player.icons.get('volume-off');
                            _this5.player.bar.set('volume', 0, 'width');
                        }
                    });
                }
            }
        },
        {
            key: 'initQualityButton',
            value: function initQualityButton(list, current) {
                var _this6 = this;
                this.player.template.quality.innerHTML = '';
                if (list.length > 1) {
                    this.player.template.quality.innerHTML = this.player.template.tplButton('Quality change', list[current].name, false, function (content) {
                        return content('tplQuality', {
                            'list': list,
                            'current': current
                        });
                    });
                    var qualityList = this.player.template.quality.querySelector('.lineplayer-button-panel');
                    if (qualityList) {
                        qualityList.addEventListener('click', function (e) {
                            if (e.target.classList.contains('lineplayer-quality-item')) {
                                _this6.player.switchVideo(_this6.player.currentChannel, parseInt(e.target.dataset.index));
                            }
                        });
                    }
                }
            }
        },
        {
            key: 'initScreenshotButton',
            value: function initScreenshotButton() {
                var _this7 = this;
                if (this.player.options.screenshot) {
                    this.player.template.screenshot.innerHTML = this.player.template.tplButton('Screenshot', 'camera');
                    var screenshotButton = this.player.template.screenshot.querySelector('button');
                    screenshotButton.addEventListener('click', function (e) {
                        e.preventDefault();
                        var canvas = document.createElement('canvas');
                        canvas.width = _this7.player.video.videoWidth;
                        canvas.height = _this7.player.video.videoHeight;
                        canvas.getContext('2d').drawImage(_this7.player.video, 0, 0, canvas.width, canvas.height);
                        var dataURL = canvas.toDataURL('image/png');
                        var fileName = ''.concat(_this7.player.template.title && _this7.player.template.title.innerHTML || 'LinePlayer', ' - ').concat(utils.currentDateTime(), '.png');
                        require('downloadjs')(dataURL, fileName, 'image/png');
                        _this7.player.events.trigger('screenshot', dataURL);
                    });
                }
            }
        },
        {
            key: 'initFullButton',
            value: function initFullButton() {
                var _this8 = this;
                this.player.template.fullScreen.innerHTML = this.player.template.tplButton('Full screen', 'full');
                var fullScreenButton = this.player.template.fullScreen.querySelector('button');
                fullScreenButton.addEventListener('click', function () {
                    _this8.player.fullScreen.toggle();
                });
            }
        },
        {
            key: 'setAutoHide',
            value: function setAutoHide() {
                var _this9 = this;
                this.show();
                clearTimeout(this.autoHideTimer);
                this.autoHideTimer = setTimeout(function () {
                    if (!_this9.player.video.paused && !_this9.disableAutoHide) {
                        _this9.hide();
                    }
                }, 2000);
            }
        },
        {
            key: 'show',
            value: function show() {
                this.player.container.classList.remove('lineplayer-hide-controller');
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.player.container.classList.add('lineplayer-hide-controller');
            }
        },
        {
            key: 'isShow',
            value: function isShow() {
                return !this.player.container.classList.contains('lineplayer-hide-controller');
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.isShow()) {
                    this.hide();
                } else {
                    this.show();
                }
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                clearTimeout(this.autoHideTimer);
            }
        }
    ]);
}();
export default Controller;